import { render, staticRenderFns } from "./RziFitoSpecies.vue?vue&type=template&id=e6842b58&scoped=true&"
import script from "./RziFitoSpecies.vue?vue&type=script&lang=js&"
export * from "./RziFitoSpecies.vue?vue&type=script&lang=js&"
import style0 from "./RziFitoSpecies.vue?vue&type=style&index=0&id=e6842b58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6842b58",
  null
  
)

export default component.exports